import React from 'react'
import { Button, Input } from 'semantic-ui-react'
import "./AdminModificarSerie.scss"
import {map} from "lodash"
import db from '../../../utils/firebase'
import { toast } from 'react-toastify'

function AdminModificarSerie({dataSerie,idSerie}) {


    const [buscar,setBuscar]=React.useState(dataSerie?.buscar?dataSerie?.buscar:[])
    const [reload,setReload]=React.useState(false)
    const [albumName, setAlbumName] = React.useState({
        
        buscar:[],
        urlPoster:""

    })
    const [loading,setLoading] = React.useState(false)

    const AgregarBuscar = () =>{

        if(albumName.buscar.length>0){
            buscar.push(albumName?.buscar?.toLowerCase())
            setReload(!reload)
        }
        
    }

    const deleteButtom = (i)=>{
        const news = buscar.filter((doc)=>doc !==i)
        setBuscar(news)
        setReload(!reload)
    }

    const ActualizarDatosSerie = ()=>{

       let arr = dataSerie

        const {id,...rest}=arr
        if(dataSerie?.buscar){
            setLoading(true)

            db.collection("series").doc(dataSerie?.id).update({
                buscar:buscar
            }).finally(()=>{
                setLoading(false)
            })
        }else{
            setLoading(true)
            db.collection("series").doc(dataSerie?.id).set({
                ...rest,
                buscar:buscar
            }).finally(()=>{
                setLoading(false)
            })

        }
        
        

    }

    const handleUpdateDate = ()=>{
        db.collection("series").doc(dataSerie.id).update({
            createAt:new Date()
        }).then(()=>{
            toast.success("fecha actualizada")
        })
    }

    const UpdateImage = ()=>{
        db.collection("series").doc(dataSerie.id).update({
            urlPoster:albumName.urlPoster
        }).then(()=>{
            toast.success("Se actualizo")
            
        })
    }




  return (
    <div>
        <div className='conatinerInptAdd' > 

        <Input
                        placeholder="Buscar"
                        onChange={(e) => setAlbumName({...albumName,buscar: e.target.value })}
                        className='inputAddBuscarSerie'

        />
  
        

        
        <Button className='botomAgregaarSerie' onClick={()=>AgregarBuscar()}  >agregar</Button>
        

        </div>
        <div className='containerBotonActualizar' >
            <Button
                content="Actualizar fecha"
                className='butonactualizarfecha'
                onClick={()=>handleUpdateDate()}
            />
        </div>
        <div>
            <Input
                            placeholder="Actualizar POSTER"
                            onChange={(e) => setAlbumName({...albumName,urlPoster: e.target.value })}
                            className='inputAddBuscarSerie'

            />
                    <Button className='botomAgregaarSerie' onClick={()=>UpdateImage()}  >Actualizar imagen</Button>

        </div>
                
                <div className='conatinerButtoms' >
                    {
                        map(buscar,(item,index)=>(
                            <Button
                                key={index}
                                className='buttomAgregados'
                                onClick={()=>deleteButtom(item)}
                                
                            >
                                {item}
                            </Button>
                        ))
                    }
                </div>
                
                <div className='conatinerBotonesAgregarYactualizar' >

                    <Button loading={loading}  onClick={()=>ActualizarDatosSerie()}  >Actualizar datos</Button>
                </div>

    </div>
  )
}

export default AdminModificarSerie